<template>
  <div class="app-container">
    <BjDivider>
      {{ $t('BusinessPurchaseApplyDetail.status') }}
      <template #right>
        <el-button v-if="isStatus === 'audit'" type="primary" @click="onEdit">{{ $t('editText') }}</el-button>
        <el-button v-if="isStatus === 'audit' && auditStatusList.includes(data.status) && permissionBtns('WAIT_FIRST_AUDIT')" type="primary" @click="firstAudit">{{ $t('BusinessPurchaseApplyDetail.firstReview') }}</el-button>
        <el-button v-if="isStatus === 'audit' && auditStatusList2.includes(data.status) && permissionBtns('WAIT_SECOND_AUDIT')" type="primary" @click="secondAudit">{{ $t('BusinessPurchaseApplyDetail.secondReview') }}</el-button>
        <el-button v-if="isStatus === 'audit' && auditStatusList3.includes(data.status) && permissionBtns('WAIT_THIRD_AUDIT')" type="primary" @click="thirdAudit">{{ $t('BusinessPurchaseApplyDetail.thirdReview') }}</el-button>
        <el-button type="primary" @click="showLog">{{ $t('BusinessPurchaseApplyDetail.operationLog') }}</el-button>
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
      </template>
    </BjDivider>
    <div class="bj-row mt20">
      <div class="bj-col bj-col-24">
        <div class="bj-form-title">
          {{ $t('BusinessPurchaseApplyDetail.status') }}: <span class="red">{{ $t(PURCHASE_STATUS_LIST.bjGet(data.status)) }}</span>
        </div>
        <div class="flex-center">
          <div class="text-center numBox">
            <p>{{ $t('BusinessPurchaseApplyDetail.number') }}</p>
            <span>{{ data.planQty || 0 }}</span>
          </div>
          <!-- <div class="text-center numBox">
            <p>{{ $t('BusinessPurchaseApplyDetail.already') }}</p>
            <span>{{ data.alreadyQty || 0 }}</span>
          </div>
          <div class="text-center numBox">
            <p>{{ $t('BusinessPurchaseApplyDetail.purchasedNot') }}</p>
            <span>{{ data.waitQty || 0 }}</span>
          </div> -->
        </div>
      </div>
    </div>
    <BjDivider> {{ $t('BusinessPurchaseApplyDetail.title') }}</BjDivider>
    <div class="bj-row mt20">
      <div class="bj-col">
        <template>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseApplyDetail.code') }}</div>
            <div class="bj-form-item-value">{{ data.code }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('table.createTimeText') }}</div>
            <div class="bj-form-item-value">{{ data.creationDate }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseComponentsPur.type') }}</div>
            <div class="bj-form-item-value">{{ $t(PURCHASE_TYPE.bjGet(data.purchaseType)) }}</div>
          </div>
        </template>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseApplyDetail.remark') }}</div>
          <div class="bj-form-item-value"><span style="color: red;">{{ data.remarks }}</span></div>
        </div>
      </div>
      <div class="bj-col">
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseApplyDetail.warehouseCode') }}</div>
          <div class="bj-form-item-value">{{ data.warehouseName }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseEntryComPage.header.supplier') }}</div>
          <div class="bj-form-item-value">{{ data.supplierName }}</div>
        </div>
        <!-- <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseApplyDetail.reviewTime') }}</div>
          <div class="bj-form-item-value">{{ data.auditDate }}</div>
        </div> -->
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseApplyDetail.reviewRemark1') }}</div>
          <div v-if="data.remark" class="bj-form-item-value quill-editor" v-html="data.remark"></div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseApplyDetail.reviewRemark2') }}</div>
          <div v-if="data.remark2" class="bj-form-item-value quill-editor" v-html="data.remark2"></div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseApplyDetail.reviewRemark3') }}</div>
          <div v-if="data.remark3" class="bj-form-item-value quill-editor" v-html="data.remark3"></div>
        </div>
      </div>
      <div class="bj-col">
        <template>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseApplyDetail.arrivalTime') }}</div>
            <div class="bj-form-item-value">{{ data.expectedDate }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseComponentsPur.postingDate') }}</div>
            <div class="bj-form-item-value">{{ data.postingDate }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseComponentsPur.documentDate') }}</div>
            <div class="bj-form-item-value">{{ data.documentDate }}</div>
          </div>
          <div class="bj-form-item">
            <div class="bj-form-item-label">{{ $t('BusinessPurchaseComponentsPur.requiredDate') }}</div>
            <div class="bj-form-item-value">{{ data.requiredDate }}</div>
          </div>
        </template>
      </div>
    </div>
    <BjDivider>
      {{ $t('BusinessPurchaseApplyDetail.productInformation') }}
    </BjDivider>
    <div class="flex">
      <span></span>
      <RightToolbar @showSetting="toolbarShow" />
    </div>
    <el-table v-if="tableShow" :data="data.goodsList" border script max-height="600">
      <el-table-column :label="$t('table.countText')" type="index" width="65" fixed="left" align="center" />
      <el-table-column v-if="sortableSetting.skuCode" label="SKU" prop="skuCode" fixed="left" width="133" align="center">
      </el-table-column>
      <el-table-column v-if="sortableSetting.planQty" :label="$t('BusinessPurchaseApplyDetail.orderQty')" prop="planQty" align="center" width="130" />
      <el-table-column v-if="sortableSetting.cnPurchasePrice" :label="$t('BusinessPurchaseApply.cnPurchasePrice')" prop="cnPurchasePrice" align="center" width="120" />
      <el-table-column v-if="sortableSetting.auPurchasePrice" :label="$t('BusinessPurchaseDetailPage.table.Australian')" prop="auPurchasePrice" align="center" width="120" />
      <el-table-column v-if="sortableSetting.price" :label="$t('BusinessPurchaseDetailPage.table.Selling')" prop="price" align="center" width="120" />
      <el-table-column v-if="sortableSetting.linkUrl" :label="$t('BusinessPurchaseDetailPage.table.Link')" prop="linkUrl" align="center" width="140">
        <template v-slot="{ row }">
          <a :href="'https://'+row.linkUrl" target="_blank">{{ row.linkUrl }}</a>
        </template>
      </el-table-column>
      <el-table-column v-if="sortableSetting.linkMinPrice" :label="$t('BusinessPurchaseDetailPage.table.Price')" prop="linkMinPrice" align="center" width="140" />
      <el-table-column v-if="sortableSetting.expressPrice" :label="$t('BusinessPurchaseDetailPage.table.Express')" prop="expressPrice" align="center" width="140" />
      <el-table-column v-if="sortableSetting.consumptionTax" :label="$t('BusinessPurchaseDetailPage.table.Consumption')" prop="consumptionTax" align="center" width="140" />
      <el-table-column v-if="data.purchaseType!=='COMMON'" :label="$t('BusinessPurchaseDetailPage.table.Platform')" prop="platformPrice" align="center" width="140" />
      <el-table-column v-if="sortableSetting.taxCode" :label="$t('BusinessPurchaseComponentsPur.table.TaxCode')" prop="taxCode" align="center" width="125" />
      <el-table-column v-if="sortableSetting.requiredDate" :label="$t('BusinessPurchaseComponentsPur.requiredDate')" prop="requiredDate" align="center" width="150" />
      <el-table-column v-if="sortableSetting.dailySales" :label="$t('BusinessPurchaseApply.table.dailySales')" prop="dailySales" align="center" width="100" />

      <el-table-column v-if="sortableSetting.estimatedProfit" :label="$t('BusinessPurchaseDetailPage.table.Estimated')" prop="estimatedProfit" align="center" width="125" />
      <el-table-column v-if="sortableSetting.estimatedProfitRate" :label="$t('BusinessPurchaseDetailPage.table.Expected')" prop="estimatedProfitRate" align="center" width="130">
        <template v-slot="{ row }">
          {{ row.estimatedProfitRate }}%
        </template>
      </el-table-column>
      <el-table-column v-if="sortableSetting.actualProfitRate" :label="$t('BusinessPurchaseDetailPage.table.Actual')" prop="actualProfitRate" align="center" width="110">
        <template v-slot="{ row }">
          {{ row.actualProfitRate | profitMarginFilter }}
        </template>
      </el-table-column>
      <el-table-column label="refund & resend rate" prop="resendRefundRate" align="center" width="149">
        <template v-slot="{ row }">
          {{ row.resendRefundRate | profitMarginFilter }}
        </template>
      </el-table-column>
      <el-table-column v-if="sortableSetting.purchaseRiskLevel" :label="$t('BusinessPurchaseDetailPage.table.risk')" prop="purchaseRiskLevel" align="center" width="117">
        <template v-slot="{ row }">
          <div v-if="row.purchaseRiskLevel">
            <span v-if="row.purchaseRiskLevel === '1'" class="dot red_dto"></span>
            <span v-else-if="row.purchaseRiskLevel === '2'" class="dot yellow"></span>
            <span v-else class="dot green"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="sortableSetting.barCode" :label="$t('BusinessPurchaseDetailPage.table.Barcode')" prop="barCode" align="center" width="120" />
      <el-table-column :label="$t('BusinessPurchaseDetailPage.table.cartonBoxBarcode')" prop="cartonBoxBarcode" align="center" width="160" />
      <el-table-column v-if="sortableSetting.brandName" :label="$t('BusinessPurchaseDetailPage.table.brand')" prop="brandName" align="center" width="120" />
      <el-table-column v-if="sortableSetting.categoryName" :label="$t('BusinessPurchaseDetailPage.table.Product1')" prop="categoryName" align="center" width="145" />
      <el-table-column v-if="sortableSetting.skuName" :label="$t('BusinessPurchaseDetailPage.table.Description')" prop="skuName" align="center" width="150" />
      <el-table-column v-if="sortableSetting.length" :label="$t('BusinessPurchaseDetailPage.table.length')" prop="length" align="center" width="140"><template v-slot="{ row }">{{ row.length }} cm</template></el-table-column>
      <el-table-column v-if="sortableSetting.width" :label="$t('BusinessPurchaseDetailPage.table.width')" prop="width" align="center" width="140"><template v-slot="{ row }">{{ row.width }} cm</template></el-table-column>
      <el-table-column v-if="sortableSetting.height" :label="$t('BusinessPurchaseDetailPage.table.high')" prop="height" align="center" width="140"><template v-slot="{ row }">{{ row.height }} cm</template></el-table-column>
      <el-table-column v-if="sortableSetting.volume" :label="$t('BusinessPurchaseDetailPage.table.Volume')" prop="volume" align="center" width="160">
        <template v-slot="{ row }">
          {{ (row.width * row.height * row.length / 1000000) }} m³
        </template>
      </el-table-column>
      <el-table-column v-if="sortableSetting.weight" :label="$t('BusinessPurchaseDetailPage.table.Weight')" prop="weight" align="center" width="120"><template v-slot="{ row }">{{ row.weight }} kg</template></el-table-column>
      <el-table-column v-if="sortableSetting.cartonLength" :label="$t('BusinessPurchaseDetailPage.table.boxLength')" prop="cartonLength" align="center" width="110">
        <template v-slot="{ row }">
          {{ row.cartonLength }} cm
        </template>
      </el-table-column>
      <el-table-column v-if="sortableSetting.cartonWidth" :label="$t('BusinessPurchaseDetailPage.table.boxWidth')" prop="cartonWidth" align="center" width="100">
        <template v-slot="{ row }">
          {{ row.cartonWidth }} cm
        </template>
      </el-table-column>
      <el-table-column v-if="sortableSetting.cartonHeight" :label="$t('BusinessPurchaseDetailPage.table.boxheight')" prop="cartonHeight" align="center" width="100">
        <template v-slot="{ row }">
          {{ row.cartonHeight }} cm
        </template>
      </el-table-column>
      <el-table-column v-if="sortableSetting.cartonVolume" :label="$t('BusinessPurchaseDetailPage.table.boxVolume')" prop="cartonVolume" align="center" width="110">
        <template v-slot="{ row }">
          {{ (row.cartonLength * row.cartonWidth * row.cartonHeight / 1000000) }} m³
        </template>
      </el-table-column>
      <el-table-column v-if="sortableSetting.cartonWeight" :label="$t('BusinessPurchaseDetailPage.table.boxWeight')" prop="cartonWeight" align="center" width="100">
        <template v-slot="{ row }">
          {{ row.cartonWeight }} kg
        </template>
      </el-table-column>
      <el-table-column v-if="sortableSetting.qty" :label="$t('BusinessPurchaseDetailPage.table.per')" prop="qty" align="center" width="110" />
      <el-table-column v-if="sortableSetting.createdName" :label="$t('BusinessPurchaseDetailPage.table.Buyer')" prop="createdName" align="center" width="140" />
    </el-table>
    <div class="mt20 mb20 flex flex-spacebetween">
      <span></span>
      <div class="font16" style="color: #3d3d3d">
        <span class="mr20">{{ $t('BusinessPurchaseDetailPage.plantQtySum') }}：<span class="font18">{{ planQtyTotal || 0 }}</span></span>
        <span class="mr20">{{ $t('BusinessPurchaseDetailPage.productVolume') }}：<span class="font18">{{ volumeTotal }} m³</span></span>
        <span>{{ $t('BusinessPurchaseDetailPage.cartonWeight') }}：<span class="font18">{{ weightTotal }} kg</span></span>
      </div>
    </div>

    <!--    审核弹窗-->
    <DialogAudit ref="DialogAudit" :audit-status="auditStatus" @confirm="onConfirm" />

    <!--    表格setting-->
    <ElementTableSortable ref="ElementTableSortable" :page-type="sortableSettingPage" :sortable-setting="sortableSetting" @settingTableTitle="settingTableTitle" />
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import DialogAudit from './components/DialogAudit.vue';
import {purchaseApi} from '@/api';
import { PURCHASE_STATUS_LIST, PURCHASE_TYPE } from '@/utils/constants';
import orderLog from '@/utils/log.js';
import RightToolbar from '../components/RightToolbar';
import ElementTableSortable from '../components/PurchaseTableSortable';

export default {
  name: 'BusinessPurchaseApplyDetail',
  components: {DialogAudit, ElementTableSortable, RightToolbar},
  mixins: [viewMiXin],
  data() {
    return {
      PURCHASE_STATUS_LIST,
      PURCHASE_TYPE,
      isStatus: this.$route.query.status,
      data: {},
      auditStatus: '1',
      auditStatusList: ['WAIT_FIRST_AUDIT', 'FIRST_AUDIT_REJECTED', 'WAIT_PRODUCED', 'WAIT_AUDIT'],
      auditStatusList2: ['WAIT_SECOND_AUDIT', 'SECOND_AUDIT_REJECTED'],
      auditStatusList3: ['WAIT_THIRD_AUDIT', 'THIRD_AUDIT_REJECTED'],
      sortableSetting: {
        skuCode: true,
        planQty: true,
        cnPurchasePrice: true,
        auPurchasePrice: true,
        price: true,
        linkUrl: true,
        linkMinPrice: true,
        expressPrice: true,
        consumptionTax: true,
        taxCode: true,
        requiredDate: true,
        dailySales: true,
        estimatedProfit: true,
        estimatedProfitRate: true,
        actualProfitRate: true,
        purchaseRiskLevel: true,
        barCode: true,
        brandName: true,
        categoryName: true,
        skuName: true,
        length: true,
        width: true,
        height: true,
        volume: true,
        weight: true,
        cartonLength: true,
        cartonWidth: true,
        cartonHeight: true,
        cartonVolume: true,
        cartonWeight: true,
        qty: true,
        createdName: true
      },
      sortableSettingPage: 'PurchaseApplyDetail',
      tableShow: true
    };
  },
  computed: {
    weightTotal() {
      if (!this.data?.goodsList?.length) return 0;
      return this.data.goodsList.reduce((pre, cur) => (pre += cur.cartonWeight), 0);
    },
    volumeTotal() {
      if (!this.data?.goodsList?.length) return 0;
      const volumeTotal = this.data.goodsList.reduce((pre, cur) => {
        const number = Math.ceil(cur.planQty / cur.qty);
        // eslint-disable-next-line no-return-assign
        return pre += (number * (cur.length * cur.width * cur.height));
      }, 0);
      return volumeTotal / 1000000;
    },
    planQtyTotal() {
      if (!this.data?.goodsList?.length) return 0;
      return this.data.goodsList.reduce((pre, cur) => (pre += cur.planQty), 0);
    },
  },
  watch: {},
  created() {
    if (localStorage.getItem('PurchaseApplyDetailTableTitleSetting')) {
      this.sortableSetting = JSON.parse(localStorage.getItem('PurchaseApplyDetailTableTitleSetting'));
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    permissionBtns(val) {
      return this.$store.state.user.permissionBtns.includes(val.toLocaleLowerCase());
    },
    /** 编辑操作 */
    onEdit() {
      this.$toPage('BusinessPurchaseApplyIndexEdit', {
        id: this.$route.query.id,
        code: this.$route.query.code,
      });
    },
    settingTableTitle(value) {
      localStorage.setItem('PurchaseApplyDetailTableTitleSetting', JSON.stringify(value));
      this.tableShow = false;
      this.sortableSetting = value;
      setTimeout(() => (this.tableShow = true), 500);
    },
    toolbarShow() {
      this.$nextTick(() => {
        this.$refs.ElementTableSortable.show();
      });
    },
    handleClose() {
      this.cancel();
    },
    // 一审
    firstAudit() {
      this.auditStatus = '1';
      this.$refs.DialogAudit.show(this.$t('BusinessPurchaseApplyDetail.firstReview'));
    },
    // 二审
    secondAudit() {
      this.auditStatus = '2';
      this.$refs.DialogAudit.show(this.$t('BusinessPurchaseApplyDetail.secondReview'));
    },
    // 三审
    thirdAudit() {
      this.auditStatus = '3';
      this.$refs.DialogAudit.show(this.$t('BusinessPurchaseApplyDetail.thirdReview'));
    },
    onConfirm(item) {
      // 赋值审核意见
      const data = {
        ...item,
        ids: [
          {
            id: this.data.id,
            objectVersionNumber: this.data.objectVersionNumber
          }
        ]
      };
      // 调用审核接口
      purchaseApi.auditApplys(data).then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.getData();
              }, 500);
            } else {
              this.msgError(res.message);
            }
      });
    },
    showLog() {
      orderLog(
        this.$BjDialogListConfig['purchaseDefault'](`${this.$t('BusinessPurchaseApplyDetail.dialogText1')} ${this.data.code} ${this.$t('BusinessPurchaseApplyDetail.dialogText2')}`, {
          defaultQuery: {
            recordId: this.$route.query.id,
            recordType: 'APPLY',
          },
          search: [],
        }),
      );
    },
    getData() {
      purchaseApi['getApplysDetail']({
        id: this.$route.query.id,
        code: this.$route.query.code,
      }).then(async res => {
          if (!res?.goodsList) return;
          const skuCode = res.goodsList.map(item => item.skuCode);
          const skuList = await purchaseApi.purchaseGoodsImport(skuCode);
          if (!skuList.length) return;
          const goodsList = [];
          skuList.forEach(v1 => {
          res.goodsList.forEach(v2 => {
            if (v2.skuCode === v1.skuCode) {
              if (!v1.cartonHeight || !v1.cartonLength || !v1.cartonWidth) {
                goodsList.push(
                  { ...v1,
                    ...v2,
                    cartonHeight: v1.height,
                    cartonLength: v1.length,
                    cartonWidth: v1.width,
                    cartonWeight: v1.cartonWeight || 0,
                    qty: v1.qty || 1,
                    createdName: res.createdName,
                    categoryName: v1.categoryStr
                  });
              } else {
                goodsList.push(
                  { ...v1,
                    ...v2,
                    qty: v1.qty || 1,
                    cartonWeight: v1.cartonWeight || 0,
                    createdName: res.createdName,
                    categoryName: v1.categoryStr
                  });
              }
            }
          });
        });
        this.data = res;
        this.data.goodsList = goodsList;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.font18 {
  font-size: 18px;
}
.flex-center {
  justify-content: left;
}

.numBox {
  position: relative;
  flex: 0 0 160px;
  padding-bottom: 15px;
}

.numBox p {
  font-size: 12px;
}

.numBox::after {
  position: absolute;
  content: '';
  height: 5px;
  bottom: 0;
  left: 15px;
  right: 15px;
  display: block;
  // background-color: red;
}

.numBox:nth-child(1):after {
  background-color: $pink;
}

.numBox:nth-child(2):after {
  background-color: $green;
}

.numBox:nth-child(3):after {
  background-color: $sub-dark;
}
.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}

.red_dto {
  background-color: red;
}

.yellow {
  background-color: yellow;
}

.green {
  background-color: green;
}
.remark {
  color: #409eff;
  text-decoration: underline;
  cursor: pointer;
}
::v-deep .quill-editor {
  line-height: 15px;
    p {
        color: red;
      }
   img{
    width: 40px;
    height: auto;
  }
   a{
    text-decoration: underline;
    color: #0b57d0;
  }
}
</style>
